export default {"src":"/bnb/_next/static/media/moon_dark.684d1dc0.svg","height":16,"width":16};